import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function TermsOfUse() {
  const { lang } = useLang();

  return (
    <div style={{ background: '#0A0B0F', minHeight: '100vh' }} className="py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to={`/${lang}`}
          className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#BFC3C9] transition-colors mb-8"
        >
          <ArrowLeft size={20} />
          <span>{lang === 'ru' ? 'Назад на главную' : 'Volver a inicio'}</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-white mb-8 font-heading">
          {lang === 'ru' ? 'Условия использования' : 'Términos de Uso'}
        </h1>

        <div className="prose prose-invert max-w-none">
          {lang === 'ru' ? (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Принятие условий</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Используя веб-сайт KidsMafia (далее «Сайт»), управляемый KIDS MAFIA SL, вы соглашаетесь с настоящими Условиями использования. Если вы не согласны с какой-либо частью этих условий, вы не должны использовать данный Сайт.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Использование сайта</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Вы соглашаетесь использовать этот Сайт только в законных целях и таким образом, который не нарушает права других лиц и не ограничивает или препятствует их использованию и пользованию Сайтом.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Запрещается:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Использовать Сайт любым способом, который может повредить, отключить, перегрузить или нарушить работу Сайта</li>
                  <li>Пытаться получить несанкционированный доступ к Сайту, серверам или любым связанным базам данных</li>
                  <li>Копировать, воспроизводить или распространять содержимое Сайта без письменного разрешения</li>
                  <li>Использовать Сайт для передачи вредоносного программного обеспечения</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Интеллектуальная собственность</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Все содержимое Сайта, включая текст, графику, логотипы, изображения, аудио- и видеоклипы, является собственностью KIDS MAFIA SL или ее лицензиаров и защищено испанскими и международными законами об авторском праве.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Торговая марка и логотип KidsMafia являются зарегистрированными товарными знаками KIDS MAFIA SL. Использование этих знаков без письменного разрешения запрещено.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Информация о франшизе</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Информация, представленная на этом Сайте о франшизе KidsMafia, носит информационный характер. Она не является предложением к продаже франшизы и не гарантирует конкретных результатов или доходов.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Мы стремимся обеспечить точность информации на Сайте, но не гарантируем, что она полна, точна или актуальна. Пожалуйста, свяжитесь с нами напрямую для получения подробной и актуальной информации.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Ограничение ответственности</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Сайт предоставляется «как есть» без каких-либо гарантий, явных или подразумеваемых. KIDS MAFIA SL не несет ответственности за:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Любые прямые, косвенные, случайные или последующие убытки, возникающие в результате использования или невозможности использования Сайта</li>
                  <li>Любые ошибки или упущения в содержимом Сайта</li>
                  <li>Любые перерывы или прекращение работы Сайта</li>
                  <li>Любые вирусы или вредоносное программное обеспечение, полученное через Сайт</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Внешние ссылки</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Сайт может содержать ссылки на внешние веб-сайты, которые не управляются KIDS MAFIA SL. Мы не контролируем содержимое этих сайтов и не несем ответственности за их содержимое, политику конфиденциальности или практику.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Изменения в условиях</h2>
                <p className="text-[#BFC3C9] mb-4">
                  KIDS MAFIA SL оставляет за собой право изменять эти Условия использования в любое время. Любые изменения будут опубликованы на этой странице. Продолжение использования Сайта после публикации изменений означает ваше согласие с новыми условиями.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Применимое законодательство</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Настоящие Условия использования регулируются и толкуются в соответствии с законодательством Испании. Любые споры, возникающие в связи с этими условиями, подлежат исключительной юрисдикции судов Валенсии, Испания.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">9. Контакты</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Если у вас есть вопросы об этих Условиях использования, свяжитесь с нами:<br />
                  <strong>KIDS MAFIA SL</strong><br />
                  <strong>Адрес:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a><br />
                  <strong>NIF:</strong> B22815575
                </p>
              </section>
            </>
          ) : (
            <>
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">1. Aceptación de los Términos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Al utilizar el sitio web de KidsMafia (en adelante, el «Sitio»), gestionado por KIDS MAFIA SL, usted acepta estos Términos de uso. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar este Sitio.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">2. Uso del Sitio</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Usted acepta usar este Sitio solo con fines legales y de manera que no infrinja los derechos de otros ni restrinja o impida su uso y disfrute del Sitio.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Está prohibido:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Utilizar el Sitio de cualquier manera que pueda dañar, deshabilitar, sobrecargar o deteriorar el funcionamiento del Sitio</li>
                  <li>Intentar obtener acceso no autorizado al Sitio, servidores o cualquier base de datos asociada</li>
                  <li>Copiar, reproducir o distribuir el contenido del Sitio sin permiso por escrito</li>
                  <li>Usar el Sitio para transmitir software malicioso</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">3. Propiedad Intelectual</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Todo el contenido del Sitio, incluyendo texto, gráficos, logotipos, imágenes, clips de audio y video, es propiedad de KIDS MAFIA SL o sus licenciantes y está protegido por las leyes españolas e internacionales de derechos de autor.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  La marca y el logotipo de KidsMafia son marcas registradas de KIDS MAFIA SL. El uso de estas marcas sin permiso por escrito está prohibido.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">4. Información sobre la Franquicia</h2>
                <p className="text-[#BFC3C9] mb-4">
                  La información presentada en este Sitio sobre la franquicia KidsMafia es de carácter informativo. No constituye una oferta de venta de franquicia ni garantiza resultados o ingresos específicos.
                </p>
                <p className="text-[#BFC3C9] mb-4">
                  Nos esforzamos por garantizar la precisión de la información en el Sitio, pero no garantizamos que sea completa, precisa o actualizada. Por favor, contáctenos directamente para obtener información detallada y actualizada.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">5. Limitación de Responsabilidad</h2>
                <p className="text-[#BFC3C9] mb-4">
                  El Sitio se proporciona «tal cual» sin garantías de ningún tipo, expresas o implícitas. KIDS MAFIA SL no será responsable por:
                </p>
                <ul className="text-[#BFC3C9] space-y-2 list-disc pl-6">
                  <li>Cualquier daño directo, indirecto, incidental o consecuente que surja del uso o la imposibilidad de usar el Sitio</li>
                  <li>Cualquier error u omisión en el contenido del Sitio</li>
                  <li>Cualquier interrupción o cese del funcionamiento del Sitio</li>
                  <li>Cualquier virus o software malicioso obtenido a través del Sitio</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">6. Enlaces Externos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  El Sitio puede contener enlaces a sitios web externos que no son gestionados por KIDS MAFIA SL. No controlamos el contenido de estos sitios y no somos responsables de su contenido, política de privacidad o prácticas.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">7. Cambios en los Términos</h2>
                <p className="text-[#BFC3C9] mb-4">
                  KIDS MAFIA SL se reserva el derecho de modificar estos Términos de uso en cualquier momento. Cualquier cambio se publicará en esta página. El uso continuado del Sitio después de la publicación de cambios implica su aceptación de los nuevos términos.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">8. Legislación Aplicable</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Estos Términos de uso se rigen e interpretan de acuerdo con la legislación española. Cualquier disputa que surja en relación con estos términos estará sujeta a la jurisdicción exclusiva de los tribunales de Valencia, España.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-white mb-4">9. Contacto</h2>
                <p className="text-[#BFC3C9] mb-4">
                  Si tiene preguntas sobre estos Términos de uso, contáctenos:<br />
                  <strong>KIDS MAFIA SL</strong><br />
                  <strong>Domicilio:</strong> Calle Puebla de Valverde 4, 46014 Valencia, Spain<br />
                  <strong>Email:</strong> <a href="mailto:kidsmafia.vlc@gmail.com" className="text-[#D4AF37] hover:underline">kidsmafia.vlc@gmail.com</a><br />
                  <strong>NIF:</strong> B22815575
                </p>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
